import React, { useState, useEffect } from "react";
import { useRecoilValue } from "recoil";
import { useApi } from "../../../hooks/useApi";
import LineBtn from "../../Button/LineBtn";
import Blank from "../../DefaultStyles/Blank";
import LineBox from "../../DefaultStyles/LineBox";
import SpaceBetween from "../../DefaultStyles/SpaceBetween";
import TitleWithLine from "../../DefaultStyles/TitleWithLine";
import VerticalTable from "../../Table/VerticalTable";
import { authType } from "../../../pages/Login";
import DailyCheckListModal from "./DailyCheckListModal";
import Loader from "../../DefaultStyles/Loader";

export interface ICheckList {
  list: string;
  admin: string;
}

export default function DailyCheckList() {
  const auth = useRecoilValue(authType);
  const [checkListModal, setCheckListModal] = useState(false);
  const [verticalList, setVericalList] = useState<string[][]>([]);

  const { response, loading, fetchData } = useApi({
    method: "get",
    url: auth?.comment ? `checklist?page=0&size=10` : undefined,
  });

  const defaultInfoHeader = [
    Array(response?.status === 200 ? +response?.data?.totalCount! : 3)
      .fill(1)
      .map((_, i) => `${i + 1}`),
  ];

  useEffect(() => {
    if (response?.status === 200) {
      const list: string[][] = [];

      response?.data?.items?.forEach((d: ICheckList) => {
        list.push([d?.list]);
      });

      setVericalList(list);
    }
  }, [response]);

  return (
    <>
      <LineBox>
        <SpaceBetween>
          <TitleWithLine title="데일리 체크 리스트" />
          <LineBtn
            btnText="편집"
            icon="edit"
            btnClickEvent={() => setCheckListModal(true)}
          />
        </SpaceBetween>

        <Blank blankHeight={18} />

        <VerticalTable
          tableHeaderData={defaultInfoHeader[0]}
          tableFlexBodyData={verticalList}
          tableMinWidth={250}
        />
      </LineBox>

      {loading && <Loader />}

      {checkListModal && (
        <DailyCheckListModal
          closeEvent={() => setCheckListModal(false)}
          confirmEvent={() =>
            fetchData({
              method: "get",
              url: auth?.comment ? `checklist?page=0&size=10` : undefined,
            })
          }
          list={[].concat(...(verticalList as never[]))}
        />
      )}
    </>
  );
}
